import React, { useEffect, useState } from 'react';
import { useGame } from '../context/GameContext';
import './Leaderboard.css';

const MEDAL = { 1: '&#127947;', 2: '&#129352;', 3: '&#129353;' };

export default function Leaderboard() {
  const { username, level, xp, unlockedAchievements } = useGame();
  const [board, setBoard] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/leaderboard')
      .then(r => r.json())
      .then(data => {
        // Inject current player
        const playerEntry = {
          rank: 0,
          username: username + ' (You)',
          level,
          xp,
          badge_count: unlockedAchievements.length,
          isYou: true,
        };
        const combined = [...data, playerEntry]
          .sort((a, b) => b.xp - a.xp)
          .map((p, i) => ({ ...p, rank: i + 1 }));
        setBoard(combined);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading-state">Loading leaderboard...</div>;

  return (
    <div>
      <div className="section-header" style={{ marginBottom: 28 }}>
        <div>
          <h1 className="section-title" style={{ fontSize: '1.8rem' }}>Leaderboard</h1>
          <p className="section-subtitle">Top learners ranked by XP</p>
        </div>
      </div>

      {/* Top 3 podium */}
      <div className="podium">
        {board.slice(0, 3).map(p => (
          <div key={p.rank} className={`podium-entry rank-${p.rank} ${p.isYou ? 'you' : ''}`}>
            <div className="podium-medal" dangerouslySetInnerHTML={{ __html: MEDAL[p.rank] }} />
            <div className="podium-avatar">{p.username[0]?.toUpperCase()}</div>
            <div className="podium-name">{p.username}</div>
            <div className="podium-xp">{p.xp} XP</div>
            <div className="podium-level">Lvl {p.level}</div>
          </div>
        ))}
      </div>

      {/* Full table */}
      <div className="lb-table card">
        <div className="lb-header-row">
          <span className="lb-col rank">Rank</span>
          <span className="lb-col name">Player</span>
          <span className="lb-col level">Level</span>
          <span className="lb-col xp">XP</span>
          <span className="lb-col badges">Badges</span>
        </div>
        {board.map(p => (
          <div key={p.rank} className={`lb-row ${p.rank <= 3 ? 'top3' : ''} ${p.isYou ? 'you' : ''}`}>
            <span className="lb-col rank">
              {MEDAL[p.rank]
                ? <span dangerouslySetInnerHTML={{ __html: MEDAL[p.rank] }} />
                : <span className="rank-num">#{p.rank}</span>
              }
            </span>
            <span className="lb-col name">
              <div className="lb-avatar">{p.username[0]?.toUpperCase()}</div>
              <span className="lb-username">{p.username}</span>
            </span>
            <span className="lb-col level">
              <span className="lb-level-badge">LVL {p.level}</span>
            </span>
            <span className="lb-col xp">
              <span className="lb-xp">{p.xp.toLocaleString()}</span>
            </span>
            <span className="lb-col badges">
              <span className="lb-badges">&#9830; {p.badge_count}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
